@if (columnDefinition.filterable) {
  <div class="dropdown" ngbDropdown>
    <i role="button" id="dropdownMenuLink" ngbDropdownToggle aria-haspopup="true" aria-expanded="false"
        class="material-icons" style="line-height: 16px; font-size: 18px; cursor:pointer;"
        [style.color]="columnDefinition.filterTerm?'black':'lightgray'"
        (click)="$event.stopPropagation()">filter_list</i>
    <div #popupContents class="dropdown-menu" ngbDropdownMenu aria-labelledby="dropdownMenuLink">
        <div style="display:flex; flex-direction:row; padding: 10px;" (click)="performChecks($event, d)">
            <div class="d-inline-block" style="margin-right: 5px;" ngbDropdown #opSelectorToggle="ngbDropdown"
                (click)="$event.stopPropagation()">
                <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>{{filterOp.text}}</button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  @for (option of filterOps; track $index) {
                    <button class="dropdown-item"
                      (click)="opSelected(option)">{{option.text}}</button>
                  }
                </div>
            </div>
            <input placeholder="dd/mm/yyyy" name="dp" [(ngModel)]="selectedDate" ngbDatepicker #d="ngbDatepicker"
                [autoClose]="false" (click)="$event.stopPropagation()" (select)="dateSelected(d)">
            <i role="button" style="cursor:pointer; margin-left: 5px;" class="material-icons"
                (click)="toggleCalendar($event, d)">today</i>
            <i class="material-icons" style="vertical-align: middle !important; margin-left: 5px;"
                (click)="clear($event)">clear</i>
        </div>
    </div>
  </div>
}
